module.exports = __webpack_public_path__ + "laptop.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/laptop.svg
// module id = 1149
// module chunks = 10